"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var inputDeleteChinese = function inputDeleteChinese(event, path) {
  if (_store.default.state.app.inputChineseCompanyConfig[_store.default.state.user.userInfo.companyCode] && !_store.default.state.app.invalidInputChineseMenuConfig[path]) {
    if (event === 'tips') {
      return this.$t('tips.inputChineseTip');
    }
    var input = event.target;
    var value = input.value;
    var pattern = /[^\x00-\xff]/g;
    if (pattern.test(value)) {
      (0, _elementUi.Message)({
        message: this.$t('tips.inputChineseTip'),
        type: 'warning',
        duration: 2 * 1000,
        customClass: 'zZindex'
      });
      input.value = value.replace(/[^\x00-\xff]/g, '');
    }
  }
};
var _default = exports.default = inputDeleteChinese;